// extracted by mini-css-extract-plugin
export default {"container":"suspensePageFallBack_container__C16fz"};